var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('pt-sample-recollect-detail',{staticClass:"pt-sample-recollect-detail__withData",attrs:{"loading":_vm.loading,"sampleId":_vm.sampleId,"orderDetail":_vm.orderDetail,"recollectPrice":_vm.recollectPrice,"sampleType":_vm.sampleType}})}
var staticRenderFns = []

export { render, staticRenderFns }